import { Instagram, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="bg-bordeaux text-white border-t border-white/10 px-6 md:px-12 lg:px-24 py-14"
        >
            <div className="max-w-[1600px] mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
                    <div>
                        <div className="flex items-center gap-3">
                            <img
                                src="/logo.png"
                                alt="Logo Mélanie Perez"
                                className="w-16 h-16 md:w-20 md:h-20 object-contain"
                            />
                            <div className="leading-tight">
                                <p className="font-display text-2xl md:text-3xl text-white">
                                    Mélanie <span className="text-fuchsia">Perez</span>
                                </p>
                                <p className="text-[10px] uppercase tracking-[0.28em] text-gold mt-1">
                                    Créatrice de contenu &amp; UGC
                                </p>
                            </div>
                        </div>
                        <p className="text-white/60 text-sm mt-4 max-w-xs">
                            Créatrice UGC à Bordeaux. Vidéos et contenus pour marques,
                            restaurants, beauté, lifestyle et expériences.
                        </p>
                    </div>

                    <div className="flex flex-col gap-3 md:items-center">
                        <p className="eyebrow !text-gold">Navigation</p>
                        <div className="flex flex-wrap gap-x-6 gap-y-2 md:justify-center mt-2">
                            {[
                                { href: "#about", l: "À propos" },
                                { href: "#portfolio", l: "Portfolio" },
                                { href: "#services", l: "Services" },
                                { href: "#contact", l: "Contact" },
                            ].map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    className="text-xs uppercase tracking-[0.22em] hover:text-fuchsia transition-colors"
                                    data-testid={`footer-link-${l.l.toLowerCase().replace(/\s|à/g, "")}`}
                                >
                                    {l.l}
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="md:text-right">
                        <p className="eyebrow !text-gold">Suivez-moi</p>
                        <div className="mt-3 flex md:justify-end flex-wrap gap-x-4 gap-y-2">
                            <a
                                href="https://www.instagram.com/melanie.creatrice/"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] hover:text-gold transition-colors"
                                data-testid="footer-instagram"
                            >
                                Instagram <ArrowUpRight className="w-3.5 h-3.5" />
                            </a>
                            <a
                                href="https://www.tiktok.com/@melanie.creatrice"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] hover:text-gold transition-colors"
                                data-testid="footer-tiktok"
                            >
                                TikTok <ArrowUpRight className="w-3.5 h-3.5" />
                            </a>
                            <a
                                href="https://www.facebook.com/melanie.peyre.71?locale=fr_FR"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] hover:text-gold transition-colors"
                                data-testid="footer-facebook"
                            >
                                Facebook <ArrowUpRight className="w-3.5 h-3.5" />
                            </a>
                            <a
                                href="mailto:contact@melanie-creatrice.fr"
                                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] hover:text-gold transition-colors"
                                data-testid="footer-email"
                            >
                                Email <Mail className="w-3.5 h-3.5" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                    <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">
                        © 2026 Mélanie Créatrice. Tous droits réservés.
                    </p>
                    <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">
                        Designed with <span className="text-fuchsia">♥</span> in Bordeaux
                    </p>
                </div>
            </div>
        </footer>
    );
}
